module.exports = __webpack_public_path__ + "static/media/05-agora.fc31f67d.png";